//import {axiosClient} from '../../main'
import Vue from 'vue'
//import axios from '../../http/axios/index.js'

export default {
  addCategory ({ commit }, category) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('/categories/add/', {category})
        .then((response) => {
          commit('ADD_CATEGORY', Object.assign(response.data.data[0]))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCategories ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/categories/all')
        .then((response) => {
          commit('SET_CATEGORY', response.data.data.categories)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCategory ({ dispatch }, category) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`/categories/update/${category.id}`, {category})
        .then((response) => {
          //commit('UPDATE_PRODUCT', response.data.data.products)
          dispatch('fetchCategories')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeCategory ({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.delete(`/categories/remove/${categoryId}`)
        .then((response) => {
          commit('REMOVE_CATEGORY', categoryId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
